export default function FooterSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#2c2218] text-[#d4c4b0] pt-20 pb-10 px-6 lg:px-12">
      <div className="max-w-7xl mx-auto">
        {/* Top section */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16 pb-16 border-b border-white/10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <h2 className="font-cormorant text-3xl text-white font-light tracking-widest mb-4">
              Bloom <span className="text-[#c4956a] italic">Flower</span> Studio
            </h2>
            <p className="font-noto text-sm text-[#a89880] leading-relaxed mb-6 max-w-sm">
              上質なフラワーアレンジメントとブライダルフラワーで、あなたの大切な瞬間を美しく彩ります。
            </p>
            <div className="flex gap-3">
              {[
                { icon: 'ri-instagram-line', href: 'https://www.instagram.com/' },
                { icon: 'ri-twitter-x-line', href: 'https://www.x.com/' },
                { icon: 'ri-facebook-circle-line', href: 'https://www.facebook.com/' },
              ].map(social => (
                <a
                  key={social.icon}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 hover:border-[#c4956a] hover:text-[#c4956a] transition-colors cursor-pointer"
                >
                  <i className={`${social.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div>
            <p className="font-noto text-xs tracking-[0.3em] text-[#c4956a] uppercase mb-6">Navigation</p>
            <ul className="space-y-3">
              {[
                { label: 'About', id: 'about' },
                { label: 'Services', id: 'services' },
                { label: 'Gallery', id: 'gallery' },
                { label: 'Booking', id: 'booking' },
              ].map(link => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollTo(link.id)}
                    className="font-noto text-sm text-[#a89880] hover:text-white transition-colors cursor-pointer"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p className="font-noto text-xs tracking-[0.3em] text-[#c4956a] uppercase mb-6">Contact</p>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-[#c4956a] text-sm mt-0.5"></i>
                <p className="font-noto text-sm text-[#a89880]">東京都渋谷区神宮前 3-12-8</p>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-[#c4956a] text-sm"></i>
                <a href="tel:0356789012" className="font-noto text-sm text-[#a89880] hover:text-white transition-colors cursor-pointer">
                  03-5678-9012
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-[#c4956a] text-sm"></i>
                <a href="mailto:hello@bloom-flower.jp" className="font-noto text-sm text-[#a89880] hover:text-white transition-colors cursor-pointer">
                  hello@bloom-flower.jp
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line text-[#c4956a] text-sm mt-0.5"></i>
                <p className="font-noto text-sm text-[#a89880]">火〜土 10:00 – 18:00</p>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-noto text-xs text-[#6b5c4e]">
            &copy; 2026 Bloom Flower Studio. All rights reserved.
          </p>
          <a
            href="https://readdy.ai/?origin=logo"
            className="font-noto text-xs text-[#6b5c4e] hover:text-[#a89880] transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
